module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/01-01.afd15a8c.mp3";